<template>
  <div>
    <h1>Financeiro</h1>
    <v-container grid-list-md>
      <v-card>
        <v-card-title primary-title>Parâmetros da Busca</v-card-title>
        <v-layout wrap px-3>
          <v-flex md8>
            <Combobox
              label="Excursão"
              searchEndpoint="/trips/groupTrips"
              item-text="name"
              item-value="id"
              ref="filterGroupTripPicker"
              @change="onSelectedGroupTrip"
            ></Combobox>
          </v-flex>
          <v-flex md4>
            <v-text-field
              name="filterContractNumber"
              label="Contrato Núm."
              id="filterContractNumber"
              v-model="filters.contractNumber"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout wrap px-3>
          <v-flex md2>
            <DatePicker
              name="filterPeriodStartDate"
              label="Criada desde"
              id="filterPeriodStartDate"
              v-model="filters.periodStartDate"
            />
          </v-flex>
          <v-flex md2>
            <DatePicker
              name="filterPeriodEndDate"
              label="Criada até"
              id="filterPeriodEndDate"
              v-model="filters.periodEndDate"
            />
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex md2>
            <DatePicker
              name="filterReceivedStartDate"
              label="Recebido desde"
              id="filterReceivedStartDate"
              v-model="filters.receivedStartDate"
            />
          </v-flex>
          <v-flex md2>
            <DatePicker
              name="filterReceivedEndDate"
              label="Recebido até"
              id="filterReceivedEndDate"
              v-model="filters.receivedEndDate"
            />
          </v-flex>
        </v-layout>
        <v-layout wrap px-3>
          <v-flex md2>
            <v-select
              :items="paymentStatuses"
              item-value="value"
              item-text="text"
              name="filterPaymentStatus"
              id="filterPaymentStatus"
              label="Situação"
              v-model="filters.paid"
            ></v-select>
          </v-flex>
          <v-flex md10>
            <Combobox
              label="Unidade"
              searchEndpoint="/branches"
              item-text="name"
              item-value="id"
              ref="filterBranchPicker"
              @change="onSelectedBranch"
            ></Combobox>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-btn @click="reset" text>Limpar Filtros</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="request(true)" text>Consultar</v-btn>
        </v-card-actions>
      </v-card>
      <p></p>
      <v-card>
        <v-card-title>
          <v-btn
            v-if="this.selected && this.selected.length > 0 && this.canProcess"
            @click="toggleAccountProcessingCheck"
          >
            <v-icon>{{
              this.selected &&
              this.selected.length > 0 &&
              this.selected[0].processingDate != null
                ? "attach_money"
                : "money_off"
            }}</v-icon>
            {{
              this.selected &&
              this.selected.length > 0 &&
              this.selected[0].processingDate != null
                ? "Desfazer"
                : "Processar"
            }}
            Baixa
          </v-btn>
          <v-spacer></v-spacer>
          <v-pagination
            v-model="pagination.current"
            :total-visible="Math.min(6, pagination.totalPages)"
            :length="pagination.totalPages"
            @input="request()"
            @next="request()"
            @previous="request()"
          ></v-pagination>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          :single-select="true"
          item-key="id"
          v-model="selected"
          hide-default-footer
          class="elevation-1"
        >
          <v-progress-linear
            slot="progress"
            color="blue"
            indeterminate
          ></v-progress-linear>

          <template slot="no-data">
            <v-alert :value="true" color="warning" icon="warning"
              >Nenhum registro encontrado :(</v-alert
            >
          </template>

          <template slot="item" slot-scope="props">
            <tr @click="selected = [props.item]">
              <td>
                <v-checkbox
                  v-if="canProcess"
                  v-model="selected"
                  :value="props.item"
                  style="margin:0px;padding:0px"
                  hide-details
                ></v-checkbox>
              </td>
              <td>{{ props.item.date | moment("L") }}</td>
              <td>{{ props.item.contractId }}</td>
              <td class="text-right">{{ props.item.amount | money }}</td>
              <td>{{ getPaymentType(props.item.paymentType) }}</td>
              <td>{{ props.item.groupTripName }}</td>
              <td>{{ props.item.processingResponsibleUserName }}</td>
              <td>{{ props.item.processingDate | moment("L") }}</td>
            </tr>
          </template>
        </v-data-table>
        <v-card-actions>
          <span class="caption grey--text font-italic"
            >{{ pagination.totalItems }} registros encontrados</span
          >
          <v-spacer></v-spacer>
          <v-pagination
            v-model="pagination.current"
            :total-visible="Math.min(6, pagination.totalPages)"
            :length="pagination.totalPages"
            @input="request()"
            @next="request()"
            @previous="request()"
          ></v-pagination>
        </v-card-actions>
      </v-card>
    </v-container>
    <OperationStatusCard
      ref="executingStatusCard"
      progressMessage="Operação em progresso"
      successMessage="Pronto"
      errorMessage="Falha ao executar operação"
    />
  </div>
</template>
<script>
import api from "@/api";
import Combobox from "@/components/Shared/Combobox";
import DatePicker from "@/components/Shared/DatePicker";
import OperationStatusCard from "@/components/Shared/OperationStatusCard";
export default {
  name: "accounts-receivable",
  components: {
    Combobox,
    DatePicker,
    OperationStatusCard
  },
  data() {
    return {
      canProcess: this.$store.getters.isFullAccounting,
      loading: false,
      items: [],
      selected: [],
      pagination: {
        current: 1,
        totalPages: 0,
        totalItems: 0
      },
      paymentTypes: [
        { id: 1, text: "Espécie" },
        { id: 2, text: "Cheque" },
        { id: 3, text: "Cartão" },
        { id: 4, text: "Boleto" },
        { id: 5, text: "Transferência" }
      ],
      paymentStatuses: [
        { text: "Todas", value: null },
        { text: "Pagas", value: true },
        { text: "Não Pagas", value: false }
      ],
      filters: {
        contractTripId: null,
        contractNumber: null,
        periodStartDate: null,
        periodEndDate: null,
        paid: null,
        receivedStartDate: null,
        receivedEndDate: null,
        contractBranchId: null
      },
      headers: [
        {
          text: "",
          value: "id",
          sortable: false,
          width: 20
        },
        {
          text: "Data",
          value: "date",
          sortable: false,
          width: 20
        },
        {
          text: "Contrato",
          value: "contractId",
          sortable: false,
          width: 50
        },
        {
          text: "Valor",
          value: "amount",
          sortable: false,
          width: 150
        },
        {
          text: "Tipo",
          value: "paymentType",
          sortable: false,
          width: 50
        },
        {
          text: "Excursão",
          value: "groupTripName",
          sortable: false
        },
        {
          text: "Baixado por",
          value: "processingResponsibleUserName",
          sortable: false
        },
        {
          text: "Data Baixa",
          value: "processingDate",
          sortable: false,
          width: 20
        }
      ]
    };
  },
  methods: {
    onSelectedBranch(branch) {
      this.filters.contractBranchId = branch ? branch.id : null;
    },
    onSelectedGroupTrip(groupTrip) {
      this.filters.contractTripId = groupTrip ? groupTrip.id : null;
    },
    getPaymentType(type) {
      var paymentType = this.paymentTypes.filter(x => x.id == type)[0];
      if (paymentType) return paymentType.text;

      return null;
    },
    toggleAccountProcessingCheck() {
      var item =
        this.selected && this.selected.length > 0 ? this.selected[0] : null;
      if (item) {
        this.$refs.executingStatusCard.show();
        api
          .request(
            item.processingDate != null ? "DELETE" : "PUT",
            `/accounting/${item.id}/process`
          )
          .then(() => {
            this.$refs.executingStatusCard.succeed();
            this.request();
          })
          .catch(error => {
            this.$refs.executingStatusCard.fail(error.response.data);
          });
      }
    },
    reset() {
      this.filters = {
        contractTripId: null,
        contractNumber: null,
        periodStartDate: null,
        periodEndDate: null,
        paid: null,
        receivedStartDate: null,
        receivedEndDate: null,
        contractBranchId: null
      };
      this.request(true);
    },
    request(reset) {
      this.loading = true;
      if (reset) {
        this.pagination.current = 1;
      }
      api
        .request(
          "POST",
          `/accounting`,
          Object.assign(
            { pageSize: 10, pageIndex: this.pagination.current - 1 },
            this.filters
          )
        )
        .then(response => {
          this.loading = false;
          this.items = response.data.items;
          this.selected = [];
          this.pagination.totalItems = response.data.totalItems;
          this.pagination.totalPages = Math.ceil(
            response.data.totalItems / response.data.currentPageSize
          );
        })
        .catch(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    this.request(true);
  }
};
</script>
